import React from "react";
import {EditGuesser} from "@api-platform/admin";

const AirportInfoEdit = props => (
        <EditGuesser {...props} resource="covid19-airport-infos"/>
);

export default AirportInfoEdit;
